import Field from "./Field";
import { TextInput } from "./FormControls";

function joinClassNames(...classNames) {
  return classNames.filter(Boolean).join(" ");
}

export function InlineFilterBar({
  as: Tag = "div",
  align = "start",
  ariaLabel,
  className = "",
  children,
  ...props
}) {
  return (
    <Tag
      className={joinClassNames(
        "ds-inline-filter-bar",
        `ds-inline-filter-bar--${align}`,
        className
      )}
      role={ariaLabel ? "group" : undefined}
      aria-label={ariaLabel}
      {...props}
    >
      {children}
    </Tag>
  );
}

export function InlineFilterGroup({
  as: Tag = "div",
  ariaLabel,
  className = "",
  children,
  ...props
}) {
  return (
    <Tag
      className={joinClassNames("ds-inline-filter-group", className)}
      role={ariaLabel ? "group" : undefined}
      aria-label={ariaLabel}
      {...props}
    >
      {children}
    </Tag>
  );
}

export function CompactDateField({
  id,
  label,
  type = "date",
  hideLabel = false,
  className = "",
  inputClassName = "",
  ...inputProps
}) {
  return (
    <Field
      id={id}
      label={label}
      className={joinClassNames(
        "ds-compact-date-field",
        hideLabel && "ds-compact-date-field--label-hidden",
        className
      )}
    >
      <TextInput
        id={id}
        type={type}
        className={joinClassNames("ds-compact-date-input", inputClassName)}
        {...inputProps}
      />
    </Field>
  );
}

export function CompactDateRange({
  from,
  to,
  type = "date",
  hideLabels = false,
  ariaLabel = "기간",
  className = "",
}) {
  return (
    <InlineFilterGroup
      ariaLabel={ariaLabel}
      className={joinClassNames("ds-compact-date-range", className)}
    >
      <CompactDateField
        type={type}
        hideLabel={hideLabels}
        {...from}
      />
      <CompactDateField
        type={type}
        hideLabel={hideLabels}
        {...to}
      />
    </InlineFilterGroup>
  );
}
